import {
    GET_PLATAFORMA_TENANTS,
    GET_PLATAFORMAS_BY_TENANT,
    ADD_PLATAFORMA_TENANT,
    UPDATE_PLATAFORMA_TENANT,
    DELETE_PLATAFORMA_TENANT,
    SET_LOADING,
    SET_ERROR,
    CLEAR_PLATAFORMAS_TENANT
} from "./plataformaTenantActions";

const plataformaTenantReducer = (state, action) => {
    switch (action.type) {
        case GET_PLATAFORMA_TENANTS:
            return {
                ...state,
                plataformaTenants: action.payload,
                loading: false,
                error: null
            };
        case GET_PLATAFORMAS_BY_TENANT:
            return {
                ...state,
                plataformasByTenant: action.payload,
                loading: false,
                error: null
            };
        case ADD_PLATAFORMA_TENANT:
            return {
                ...state,
                plataformasByTenant: [...state.plataformasByTenant, action.payload],
                loading: false,
                error: null
            };
        case UPDATE_PLATAFORMA_TENANT:
            return {
                ...state,
                plataformasByTenant: state.plataformasByTenant.map(pt =>
                    pt._id === action.payload._id ? action.payload : pt
                ),
                loading: false,
                error: null
            };
        case DELETE_PLATAFORMA_TENANT:
            return {
                ...state,
                plataformasByTenant: state.plataformasByTenant.filter(pt => pt._id !== action.payload._id),
                loading: false,
                error: null
            };
        case CLEAR_PLATAFORMAS_TENANT:
            return {
                ...state,
                plataformasByTenant: [],
                loading: false,
                error: null
            };
        case SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        default:
            return state;
    }
};

export default plataformaTenantReducer;
